export default {
  CONNECTORS_CUSTOMER: 'connectorsCustomer',
  LOGIN: 'login',
  MFA_SETTINGS: 'mfaSettings',
  SPOTLIGHT_SEARCH: 'spotlightSearch',
  SERVICE_AZUREAD_CUSTOMER_SERVICE: 'serviceAzureAdCustomerService',
  SERVICE_MSOL_PARTNERCENTER: 'serviceMsolPartnerCenter',
  SERVICE_MSOL_OFFER_MANAGEMENT: 'serviceMsolOfferManagement'
};
